import { Skeleton } from "@/components/ui/skeleton";

export function MemberDashboardSkeleton() {
  return (
    <div className="mx-auto max-w-6xl space-y-8 px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12">
      {/* Header */}
      <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
        <div className="bg-gradient-to-br from-slate-900 via-slate-800 to-amber-950 px-6 py-8 sm:px-8 sm:py-10">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
            <Skeleton className="h-20 w-20 shrink-0 rounded-2xl bg-slate-700/60" />
            <div className="flex-1 space-y-3">
              <Skeleton className="h-8 w-48 bg-slate-700/60" />
              <Skeleton className="h-4 w-56 bg-slate-700/50" />
              <Skeleton className="h-4 w-40 bg-slate-700/50" />
            </div>
          </div>
        </div>
      </div>

      {/* Stat cards */}
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div
            key={index}
            className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex-1 space-y-3">
                <Skeleton className="h-3 w-20" />
                <Skeleton className="h-8 w-24" />
                <Skeleton className="h-4 w-28" />
              </div>
              <Skeleton className="h-11 w-11 rounded-xl" />
            </div>
          </div>
        ))}
      </div>

      {/* Ledger table */}
      <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6">
        <Skeleton className="mb-1 h-6 w-40" />
        <Skeleton className="mb-5 h-4 w-52" />
        <div className="space-y-3 rounded-xl border border-slate-100 p-4">
          <Skeleton className="h-4 w-full" />
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} className="h-10 w-full" />
          ))}
        </div>
      </div>

      {/* Rewards */}
      <div className="space-y-6 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6">
        <div>
          <Skeleton className="mb-2 h-6 w-32" />
          <Skeleton className="h-4 w-56" />
        </div>
        <div className="rounded-2xl border border-amber-100 bg-gradient-to-br from-amber-50/70 via-white to-slate-50 p-5 sm:p-6">
          <Skeleton className="mb-4 h-4 w-36" />
          <div className="space-y-3">
            {Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="h-5 w-full" />
            ))}
          </div>
        </div>
      </div>

      {/* Coupons */}
      <div className="space-y-5">
        <div>
          <Skeleton className="mb-2 h-6 w-36" />
          <Skeleton className="h-4 w-52" />
        </div>
        <div className="space-y-4">
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton key={index} className="h-24 w-full rounded-2xl" />
          ))}
        </div>
      </div>

      {/* Profile */}
      <div className="rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6">
        <div className="mb-6 flex items-start justify-between">
          <div>
            <Skeleton className="mb-2 h-6 w-36" />
            <Skeleton className="h-4 w-28" />
          </div>
          <Skeleton className="h-10 w-10 rounded-xl" />
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={index} className="h-20 w-full rounded-xl" />
          ))}
        </div>
      </div>
    </div>
  );
}
